import styled from "styled-components"
import { Label } from "../../common/baseComponents"
import { SIZE } from "../../common/sizes"

export interface MainSideBarContainerProps {
    collapse: boolean
}
export const MainSideBarContainer = styled.div`
    display:flex;
    flex-flow: column;
    height: 100%;
    width: ${(props: MainSideBarContainerProps) => !props.collapse ? `260px` : '54px'};
    opacity: ${(props: MainSideBarContainerProps) => !props.collapse ? 1 : 1 };
    background-color: #2b3a66;
    & > ${Label} {
        margin-left: ${SIZE.FIVE}px;
    }
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`

export const DealerLabel = styled.div`
    margin-top: ${SIZE.FOUR}px;
    ${Label} {
        display: block;
        padding-ritght: ${SIZE.FIVE}px;
        align-items: center;
        text-align: center;
    }
`

export const NavigationalPanel = styled.div`

`

export const IconContainer = styled.div`
    display: inline-grid;
    margin-top: 23px;
    align-items: center;
    width: 54px;
    justify-items: center;
    cursor: pointer;
`
export const IconAnimation = styled.div`
    transform: ${(props: MainSideBarContainerProps) => !props.collapse ? `rotate(180deg)` : ''}; 
    transition: transform 550ms ease;
`

export const MenuContainer = styled.div`
    display:flex;
    margin-top: 12px;
`

export const SectionBar = styled.div`
    border-bottom: 1px solid #204078;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`